import { Phone } from "lucide-react";

/**
 * Sticky bottom CTA bar for mobile only.
 * "Call Now" + "Check My Coverage" (scrolls to hero form).
 */
export function BcbsilStickyCta() {
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-border shadow-[0_-4px_12px_rgba(0,0,0,0.08)]">
      <div className="grid grid-cols-2 gap-px">
        <a
          href="tel:9548279793"
          className="flex items-center justify-center gap-2 h-14 text-sm font-semibold text-primary bg-white active:bg-muted transition-colors"
        >
          <Phone className="w-4 h-4 text-accent" />
          Call Now
        </a>
        <a
          href="#saint-quiz"
          className="flex items-center justify-center h-14 text-sm font-semibold text-white bg-accent active:bg-accent/90 transition-colors"
        >
          Check My Coverage
        </a>
      </div>
    </div>
  );
}
